import { getContrastColor } from 'featureSliced/shared/utils/getContrastColor'
import styled from 'styled-components'

type NotificationsProps = {
  counter?: string | number
  isCounterOffset?: boolean
}

export const MainScreenControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

export const SidebarButtonContainer = styled.div`
  padding: 5vw;
`

export const NotificationsButtonContainer = styled(
  SidebarButtonContainer
)<NotificationsProps>`
  color: #fff;
  display: flex;
  gap: 10px;
  &::after {
    content: ${({ counter }) => (counter ? `'${counter}'` : 'unset')};

    background: red;
    position: absolute;
    z-index: 0;

    height: 18px;
    width: 18px;
    border-radius: 50%;

    display: flex;
    justify-content: center;
    align-items: center;

    top: 4vw;
    right: 4.5vw;
    right: ${({ isCounterOffset }) =>
      isCounterOffset ? `calc(4.5vw + 48px)` : '4.5vw'};
    font-size: 12px;
    font-weight: bold;
  }
`

export const MainScreenIcon = styled.div`
  /* border: 1px solid #fff; */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  aspect-ratio: 1 / 1;
  height: 38px;
  width: 38px;
  border-radius: 6px;
  ///

  color: ${({ theme }) => getContrastColor(theme.colour)};
  border: ${({ theme }) => `1px solid ${theme.colour}`};
  background-color: ${({ theme }) => theme.colour};
`
